import React, { useEffect } from 'react'
import AppLayout from '../../../../../layout/components/AppLayout'
import { useAppData } from '../../../../../context/AppDataContext';
import ProjectTaskForm from '../components/ProjectTaskForm';
import TaskDetails from '../components/TaskDetails';
import TaskStatusForm from '../components/TaskStatusForm';

function TaskDashboardPage() {
  const {projectDD, taskList,getTaskList, } = useAppData();

  useEffect(()=>{
    getTaskList();
  },[])

  const callBack =() =>{
    getTaskList();
  }

  return (
    taskList &&
    <AppLayout>
        <div className='container-fluid'>
          <div className='row'>
            
              {projectDD.map((project)=>
                <div className='col-md-3' key={project.value} >
                  <div className='card mb-2'>
                    <div className='card-header bg-dark text-info' >{project.label}</div>
                    
                      <ol className="list-group list-group-numbered rounded-0">

                        {taskList.filter((task)=>task.projectId === project.value).map(projectTask=>
                            

                              <li className="list-group-item d-flex justify-content-between align-items-start">
                                  <div className="ms-2 me-auto w-100">
                                      <div className='d-flex justify-content-between'>
                                          <div className="fw-bold"><TaskDetails taskId={projectTask.id} taskTitle={projectTask.title} /></div>
                                          <ProjectTaskForm callBack={callBack} data={projectTask} projectId={projectTask.id} />
                                      </div>
                                      
                                      <TaskStatusForm data={projectTask} callBack={callBack} />
                                  
                                      
                                  </div>
                              </li>
                          
                        )}
                      </ol>
                      <div className="list-group-item "><ProjectTaskForm callBack={callBack}  projectId={project.value} /></div>
                  </div>
                </div>
                
              )}
            </div>
          
        </div>
    </AppLayout>
    
  )
}

export default TaskDashboardPage